// extracted by mini-css-extract-plugin
module.exports = {"container":"whatsapp_container__2Y9Ux","scaleDown":"whatsapp_scaleDown__li2gn"};